<template>
  <div id="count-message-template" >
    <div class="justify-left flex mb-3">
      <vs-chip :color="colorChip" class="beta-chip-nps">
        {{instance.messaging_send || 0}} de {{maskLimitMessageTemplate(instance.messaging_limit) || 0}} conversas/24h
      </vs-chip>
      <vx-tooltip
          class="mr-3"
          position="bottom"
          text="Valor máximo de mensagens que podem ser disparadas por dia usando os Modelo de Mensagens,
                caso o limite seja atingido não será possível iniciar novos atendimentos ativamente."
      >
        <feather-icon icon="HelpCircleIcon" class="ml-2"></feather-icon>
      </vx-tooltip>
    </div>
  </div>
</template>

<script>

import { maskLimitMessageTemplate } from "@/utils";

export default {
  name: "CountMessageTemplate",
  props: {
    instance: {
      required: true,
      default() {
        return {
          messaging_send: 0,
          messaging_limit: 0
        };
      }
    }
  },
  computed:{
    colorChip(){
      if ( !this.instance.messaging_limit || this.instance.messaging_limit.includes('UNLIMITED') ) { return 'success' }

      let percent = (Number(this.instance.messaging_limit) - Number(this.instance.messaging_send)) / Number(this.instance.messaging_limit) * 100;
      if (percent < 20)      { return 'danger' }
      else if (percent < 35) { return 'warning' }
      return 'success';
    }
  },
  methods: {
    maskLimitMessageTemplate
  },
}
</script>

<style lang="scss">
#count-message-template{
  .beta-chip-nps {
    float: right;
    font-size: 0.8rem;
  }
}
</style>